(function () {
  if (window.__covetoEmbedReady) return;
  window.__covetoEmbedReady = true;

  var frames = new WeakMap();
  var lastPageFocus = document.activeElement;
  var inputVersion = 0;
  var tabNavigationUntil = 0;

  function initializeFrames() {
    document.querySelectorAll('[data-coveto-embed]').forEach(function (root) {
      var iframe = root.querySelector('[data-coveto-iframe]');
      if (!iframe || frames.has(iframe)) return;
      var state = { root: root, handled: false };
      frames.set(iframe, state);
    });
  }

  document.addEventListener('focusin', function (event) {
    if (event.target.tagName !== 'IFRAME') lastPageFocus = event.target;
  }, true);

  ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!event.isTrusted) return;
      inputVersion += 1;
      if (type === 'keydown' && event.key === 'Tab') tabNavigationUntil = performance.now() + 200;
    }, { capture: true, passive: true });
  });

  window.addEventListener('blur', function () {
    var iframe = document.activeElement;
    var state = frames.get(iframe);
    if (!state || state.handled) return;
    state.handled = true;
    if (performance.now() < tabNavigationUntil) return;
    if (state.root.id && window.location.hash === '#' + state.root.id) return;
    var bounds = iframe.getBoundingClientRect();
    // A deliberate click or tap brings the frame into view before focusing it.
    if (bounds.top < window.innerHeight && bounds.bottom > 0) return;

    var position = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
    var previousFocus = lastPageFocus;
    var version = inputVersion;
    window.requestAnimationFrame(function () {
      if (inputVersion !== version || document.activeElement !== iframe) return;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
      if (document.activeElement === iframe) {
        var tabindex = document.body.getAttribute('tabindex');
        document.body.setAttribute('tabindex', '-1');
        document.body.focus({ preventScroll: true });
        if (tabindex === null) document.body.removeAttribute('tabindex');
        else document.body.setAttribute('tabindex', tabindex);
      }
      window.scrollTo(position);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFrames, { once: true });
  else initializeFrames();
  document.addEventListener('shopify:section:load', initializeFrames);

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function parseHeight(data) {
    if (data === 'init') return null;
    if (typeof data === 'number' && isFinite(data)) return data;

    if (typeof data === 'string') {
      var parsed = Number(data);
      return isFinite(parsed) ? parsed : null;
    }

    if (data && typeof data === 'object') {
      var keys = ['height', 'iframeHeight', 'h', 'frameHeight'];
      for (var i = 0; i < keys.length; i += 1) {
        if (data[keys[i]] != null) {
          var value = Number(data[keys[i]]);
          if (isFinite(value)) return value;
        }
      }
    }

    return null;
  }

  window.addEventListener('message', function (event) {
    if (!event) return;

    document.querySelectorAll('[data-coveto-embed]').forEach(function (root) {
      if (event.origin !== root.getAttribute('data-coveto-origin')) return;

      var iframe = root.querySelector('[data-coveto-iframe]');
      if (!iframe) return;
      if (event.source !== iframe.contentWindow) return;

      if (event.data === 'init') return;

      var height = parseHeight(event.data);
      if (height == null || height <= 0) return;

      var minHeight = Number(root.getAttribute('data-coveto-min-height')) || 500;
      var maxHeight = Number(root.getAttribute('data-coveto-max-height')) || 6000;
      iframe.style.height = clamp(Math.round(height), minHeight, maxHeight) + 'px';
    });
  }, false);
})();
